import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformConversationsCard } from "./-components/platform-conversations-card";

export const Route = createFileRoute("/_authenticated/platform_/conversations")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-conversations"),
  component: PlatformConversations,
});

/** Shelby's threads on People AI's texting line. */
function PlatformConversations() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="People AI conversations"
        meta="Every thread on People AI's texting line, newest first."
      />
      <PlatformConversationsCard />
    </div>
  );
}
